import { Card } from 'antd'
import React, { useState } from 'react'
import './MessageComposer.scss'
import { ReactComponent as SendIcon } from 'resources/images/send_icon.svg'
import { useMutation } from '@tanstack/react-query'
import HTTPClient from 'services/HTTPClient'
import Button from 'components/Button'

type Props = {
    userID: string
    isConnected: boolean
    onSend: (msg: string) => void
    isInProgress: boolean
}


export default function MessageComposer({ userID, isConnected, onSend, isInProgress }: Props) {
    const [message, setMessage] = useState("")
    return (
        <div className='message-composer'>
            <Card>
                <form className="control has-icons-right" onSubmit={(event) => {
                    event.preventDefault()
                    onSend(message)
                    setMessage("")
                }}>
                    <input
                        autoFocus
                        className="input no-border"
                        type="text"
                        placeholder="Message"
                        value={message}
                        onChange={(event) => setMessage(event.target.value)}
                    />
                    <span className="icon is-small is-right">
                        <Button
                            type='submit'
                            isLoading={isInProgress}
                            disabled={!message || !isConnected}
                            disableSpinnerMargin
                            style={{ borderRadius: "12px", padding: "0.5rem 0.6rem" }}>
                            <SendIcon />
                        </Button>
                    </span>
                </form>
            </Card>
        </div>
    )
}